import { useEffect } from 'react'

interface UseLocalHeadProps {
  scssManifest: string[]
  uiProjectName: string
  productName: string
}

const useLocalHead = ({
  scssManifest,
  uiProjectName,
  productName,
}: UseLocalHeadProps) => {
  useEffect(() => {
    if (process.env.APP_ENV !== 'local') {
      return
    }

    scssManifest.forEach((fileName) => {
      require(`../../../apps/${uiProjectName}/src/styles/dist/${productName}/${fileName}.css`)
    })

    const link = document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'icon'

    document.title = 'Sage Mortgage'
    link.href = '/favicon.ico'

    document.getElementsByTagName('head')[0].appendChild(link)
  }, [])
}

export default useLocalHead
